import { render, staticRenderFns } from "./ModalCadastro.vue?vue&type=template&id=4cf74e62&scoped=true&"
import script from "./ModalCadastro.vue?vue&type=script&lang=js&"
export * from "./ModalCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf74e62",
  null
  
)

export default component.exports